@if (control) {
  @if (!disabled) {
    <div class="text-container">
      <input [ariaLabel]="label" [formControl]="control" type="text" [matAutocomplete]="panel" />
      <mat-autocomplete #panel="matAutocomplete" [displayWith]="displayLabel()" panelClass="template-search-panel">
        @for (option of filteredOptions | async; track $index) {
          <mat-option [value]="option.value">
            <span [innerHTML]="option.label | iconReplace"></span>
          </mat-option>
        }
        @for (group of filteredGroups | async; track $index) {
          <mat-optgroup [label]="group.group">
            @for (option of group.options; track $index) {
              <mat-option [value]="option.value">
                <span [innerHTML]="option.label | iconReplace"></span>
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-autocomplete>
    </div>
  } @else {
    <app-template-html [control]="control" [value]="value" />
  }
}
